export interface PaciCardData {
    Status?: string;
    StatusCode?: string;
    StatusDescription?: string;
    Civil_ID?: string;
    EngName1?: string;
    EngName2?: string;
    EngName3?: string;
    ArabicName1?: string;
    ArabicName2?: string;
    ArabicName3?: string;
    ArabicName4?: string;
    Arabic_Name_Full?: string;
    English_Name_Full?: string;
    Sex_Arabic?: string;
    Sex_English?: string;
    Nationality_Arabic?: string;
    Nationality_English?: string;
    Birthdate?: string;
    Card_Issue_Date?: string;
    Card_Expiry_Date?: string;
    Document_Number?: string;
    Card_Serial_Number?: string;
    MOI_Reference?: string;
    District?: string;
    Block_Number?: string;
    Street_Name?: string;
    Building_Plot_Number?: string;
    Unit_Type?: string;
    Unit_Number?: string;
    Floor_Number?: string;
    Blood_Type?: string;
    Guardian_Civil_ID?: string;
    Telephone?: string;
    E_Mail_Address?: string;
    Address_Unique_Key?: string;
    AddInfo1?: string;
    EmployerName?: string;
}